// packages/components/src/context/constants.js
var COMPONENT_NAMESPACE = "data-wp-component";
var CONNECTED_NAMESPACE = "data-wp-c16t";
var CONNECT_STATIC_NAMESPACE = "__contextSystemKey__";
export {
  COMPONENT_NAMESPACE,
  CONNECTED_NAMESPACE,
  CONNECT_STATIC_NAMESPACE
};
//# sourceMappingURL=constants.mjs.map
